import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "ui-dropdown__icon ui-dropdown__icon--lang" }
const _hoisted_3 = {
  key: 0,
  class: "ui-dropdown__single"
}
const _hoisted_4 = { class: "ui-dropdown__single" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "ui-dropdown__content ui-dropdown__content--language" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_lang = _resolveComponent("i-lang")!
  const _component_ui_click_outside = _resolveComponent("ui-click-outside")!
  const _component_ui_dropdown = _resolveComponent("ui-dropdown")!

  return (_openBlock(), _createBlock(_component_ui_dropdown, null, {
    default: _withCtx(({ isActive, toggle, hide }) => [
      _createVNode(_component_ui_click_outside, { do: hide }, {
        default: _withCtx(({ ref }) => [
          _createElementVNode("div", {
            class: "ui-dropdown ui-dropdown--language",
            ref: ref
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: "ui-dropdown__element",
                onClick: _withModifiers(toggle, ["prevent"])
              }, [
                _createElementVNode("span", _hoisted_2, [
                  _createVNode(_component_i_lang)
                ]),
                ($setup.CURRENT_LANGUAGE)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString($setup.CURRENT_LANGUAGE), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["ui-dropdown__icon ui-dropdown__icon--arrow", { 'is-active': isActive }])
                }, null, 2)
              ], 8, _hoisted_1),
              _createElementVNode("div", {
                class: _normalizeClass(["ui-dropdown__wrapper", { 'is-active': isActive }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.languagesList, (item) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: _normalizeClass(["ui-dropdown__item ds-link", {'current' : $setup.CURRENT_LANGUAGE ===  item.value}]),
                    href: $setup.getLanguageLink(item.value.toLowerCase())
                  }, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(item.title), 1)
                  ], 10, _hoisted_5))
                }), 256))
              ], 2)
            ])
          ], 512)
        ]),
        _: 2
      }, 1032, ["do"])
    ]),
    _: 3
  }))
}